import { EmailInput } from '../baseInputs'

type Props = {
  helper?: string
}

const Email = ({ helper, ...rest }: Props) => {
  const name = 'email'
  const label = 'Email'

  return <EmailInput name={name} label={label} helper={helper} {...rest} />
}

export default Email
